import { typedFetchNoImpersonate, zodValidator } from "~/api/typed-fetch";

import {
  OperatorsResponseSchema,
  OperatorsSearchSchema,
  type Operator,
} from "../schemas";

async function getOperators(signal?: AbortSignal): Promise<Operator[]> {
  const response = await typedFetchNoImpersonate("/enums/", {
    validateResponse: zodValidator(OperatorsResponseSchema),
    validateSearch: zodValidator(OperatorsSearchSchema, { operator: "1" }),
    signal,
  });

  return response.operators;
}

export { getOperators };
